module.exports = __webpack_public_path__ + "img/easter_island_head_with_gum_gum.525d4b66.jpg";